<template>
  <q-select
    :model-value="normalizedModelValue"
    @update:model-value="onModelUpdate"
    label="Workflow name"
    :options="orderedOptions"
    option-label="label"
    option-value="value"
    map-options
    emit-value
    multiple
    options-dense
    outlined
    dense
    class="service-select"
    clearable
  >
    <template v-slot:before-options>
      <div class="workflow-search-holder q-pa-sm">
        <q-input v-model.trim="search" dense outlined clearable placeholder="Search workflow name">
          <template v-slot:prepend>
            <q-icon name="search" />
          </template>
        </q-input>
      </div>
    </template>

    <template v-slot:option="scope">
      <q-item clickable v-ripple @click="scope.toggleOption(scope.opt)">
        <q-item-section avatar>
          <q-icon :name="isSelected(scope.opt.value) ? 'check_box' : 'check_box_outline_blank'" color="positive" />
        </q-item-section>
        <q-item-section>
          <q-item-label :class="{ 'text-positive': isSelected(scope.opt.value) }">{{ scope.opt.label }}</q-item-label>
        </q-item-section>
      </q-item>
    </template>

    <template v-slot:no-option>
      <div class="workflow-search-holder q-pa-sm">
        <q-input v-model.trim="search" dense outlined clearable placeholder="Search workflow name">
          <template v-slot:prepend>
            <q-icon name="search" />
          </template>
        </q-input>
      </div>
      <q-item>
        <q-item-section class="text-grey">No matching workflows</q-item-section>
      </q-item>
    </template>
  </q-select>
</template>

<script>
import { getWorkflowNames } from '../api';

export default {
  name: 'WorkflowNameSelect',
  props: {
    modelValue: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      workflowNames: [],
      search: '',
    };
  },
  computed: {
    normalizedModelValue() {
      return Array.isArray(this.modelValue) ? this.modelValue : [];
    },
    selectedLookup() {
      return new Set(this.normalizedModelValue);
    },
    workflowOptions() {
      return this.workflowNames.map((name) => ({ label: name, value: name }));
    },
    filteredOptions() {
      const needle = this.search.toLowerCase();
      if (!needle.length) {
        return this.workflowOptions;
      }
      return this.workflowOptions.filter((option) => option.label.toLowerCase().includes(needle));
    },
    orderedOptions() {
      const selectedOptions = this.filteredOptions.filter((option) => this.selectedLookup.has(option.value));
      const unselectedOptions = this.filteredOptions.filter((option) => !this.selectedLookup.has(option.value));
      return [...selectedOptions, ...unselectedOptions];
    },
  },
  methods: {
    onModelUpdate(value) {
      this.$emit('update:modelValue', Array.isArray(value) ? value : []);
    },
    isSelected(value) {
      return this.selectedLookup.has(value);
    },
  },
  async mounted() {
    try {
      this.workflowNames = (await getWorkflowNames()).sort((a, b) => a.localeCompare(b));
    } catch (error) {
      this.$notify('negative', 'Error', error.message);
    }
  },
};
</script>

<style scoped lang="scss">
.workflow-search-holder {
  position: sticky;
  top: 0;
  z-index: 1;
  background: #fff;
}
</style>
